import React, {useState, useRef, useEffect} from 'react';
import ButtonPlay from '../../Icons/ButtonPlay';
import './VideoList.css';
import './VideoPlayer.css';
import ReactList from 'react-list';




const HighlightedVideo = ({firstItem, onFullScreenClicked}) => {
    return (
        <div className={'highlighted-video'} style={{marginBottom: 30}}>
            <div className="highlighted-title">{firstItem.name}</div>
            <div className='description'>{firstItem.description}</div>
            <ButtonPlay onClick={() => onFullScreenClicked(firstItem.uri)} />
            <div className='duration'>{toHHMMSS(firstItem.duration)}</div>
        </div>
    )
}


const toHHMMSS = (secs) => {
    const sec_num = parseInt(secs, 10);
    const hours = Math.floor(sec_num / 3600);
    const minutes = Math.floor(sec_num / 60) % 60;
    const seconds = sec_num % 60;

    return [hours, minutes, seconds]
        .map((v) => (v < 10 ? '0' + v : v))
        .filter((v, i) => v !== '00' || i > 0)
        .join(':');
};


const createRepeatedList = (items) => {
    let result = [];
    let noOfRepetitions = 30;
    for (let i = noOfRepetitions; i>0; i--) {
        result = [...result, ...items]
    }
    console.log({result})
    return result;
}

const VideoList = (props) => {
    const [itemList, setItemList] = useState(createRepeatedList(props.items))
    const [currentName, setCurrentName] = useState(0);
    const [firstItem, setFirstItem] = useState(props.items[0])
    const [firstItemIndex, setFirstItemIndex] = useState(0)
    const reactListRef = useRef()

    useEffect(() => {
        firstItem && props.onItemScroll(firstItem.uri)
    }, [firstItem])
    const handleCount = () => {
        const length = item.name.length - 1;

        setCurrentName((currentName) => {
            return currentName < length ? currentName + 1 : 0;
        });
    };

    const renderItem = (index, key) => {
        const item = itemList[index]
        const applyOpacityClass = index === firstItemIndex ? 'video-list-item-opacity' : '';
        const classes = 'video-list' + ' ' + applyOpacityClass;
        return (
            <div className={classes} key={key} onClick={() => {setHighlightedVideo(index)}}>
                {item.name}
            </div>
        )
    }

    const setHighlightedVideo = (itemIndex) => {
        const item = itemList[itemIndex];
        setFirstItem(item)
        setFirstItemIndex(itemIndex);
    }

    const handleScroll = () => {
        const visibleRange = reactListRef.current.getVisibleRange();
        const firstItemIndex = visibleRange[0]
        setHighlightedVideo(firstItemIndex);
    
        
    }

    return (

        <div className='full-container'>
            {
                firstItem && <HighlightedVideo firstItem={firstItem}  onFullScreenClicked={props.onFullScreenClicked}/>
            }

            <div style={{overflow: 'auto', maxHeight: 300, cursor: 'ns-resize'}} onScroll={handleScroll}>
                <ReactList
                    itemRenderer={renderItem}
                    length={itemList.length}
                    type='variable'
                    pageSize={3}
                    ref ={reactListRef}
                />
            </div>
        </div>
    );};

export default VideoList;


